import { Box } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import MessageHistory from '../MessageHistory/MessageHistory';
import UploadAndViewDocs from '../UploadAndViewDocs/UploadAndViewDocs';
import PaymentHistory from '../PaymentHistory/PaymentHistory';
import ChangePassword from 'src/pages/Admin/AccountSettings/ChangePassword';
import ScheduledInspectionList from 'src/pages/Permits/Construction/Inspection/ScheduledInspectionList';

function EditFormfeatureViews({ switchTo, setSwitchTo, applicationDetails }) {
  return (
    <Box sx={{ position: 'relative', width: '100%' }}>
      {/* Back Button */}
      <Box
        onClick={() => setSwitchTo('')}
        sx={{
          position: 'absolute',
          left: 4,
          top: 0,
          display: 'flex',
          alignItems: 'center',
          cursor: 'pointer',
          zIndex: 10,
          transform: 'translateX(-10px)',
          transition: 'transform 0.2s ease-in-out',
          '&:hover': {
            transform: 'translateX(-5px)',
          }
        }}
      >
        <Box
          sx={{
            width: 36,
            height: 36,
            borderRadius: '50%',
            backgroundColor: 'grey.100',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            boxShadow: '0px 2px 4px rgba(0, 0, 0, 0.2)',
            color: 'text.primary'
          }}
        >
          <ArrowBackIcon fontSize="small"  />
        </Box>
      </Box>

      {/* Main Content */}
      <Box sx={{ pt: 4 }}>
        {switchTo === 'Upload/View Document' || switchTo === 'View Documents' ? (
          <UploadAndViewDocs applicationDetails={applicationDetails} />
        ) : switchTo === 'View Message History' ? (
          <MessageHistory applicationDetails={applicationDetails} />
        ) : switchTo === 'View Payment History' ? (
          <PaymentHistory applicationDetails={applicationDetails} />
        ) : switchTo === 'Change Password' ? (
          <ChangePassword />
        ) : switchTo === 'View Inspection' ? (
          <ScheduledInspectionList applicationID={applicationDetails?.applicationID}/>
        ): null}
      </Box>
    </Box>
  );
}

export default EditFormfeatureViews;